import React from "react";
import styled from "styled-components";
import {ws} from "styles/tokens";

/* Thin progress bar shown above each wizard card, on the dark teal onboarding ground:
 * translucent white track with a white fill. */
const Track = styled.div`
  position: relative;
  width: 100%;
  max-width: 480px;
  height: 6px;
  border-radius: ${ws.radiusPill};
  background: rgba(255, 255, 255, 0.24);
`;

const Fill = styled.div<{fraction: number}>`
  position: absolute;
  inset: 0 auto 0 0;
  width: ${(props) => Math.round(props.fraction * 100)}%;
  border-radius: ${ws.radiusPill};
  background: #fff;
  transition: width 0.3s ease;
`;

interface Props {
  fraction: number;
}

function OnboardingProgressBar({fraction}: Props) {
  return (
    <Track>
      <Fill fraction={Math.min(Math.max(fraction, 0), 1)} />
    </Track>
  );
}

export default OnboardingProgressBar;
